(function () {
  function init(root) {
    if (root.dataset.snReady) return;
    root.dataset.snReady = '1';
    var cards = root.querySelectorAll('.sn-card');
    var panels = root.querySelectorAll('.sn-panel');
    function setOpen(id) {
      cards.forEach(function (c) {
        var on = c.getAttribute('data-mom') === id;
        c.setAttribute('data-open', on ? 'true' : 'false');
        var t = c.querySelector('.sn-card-toggle');
        if (t) t.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-mom') !== id; });
    }
    function show(id, scroll) {
      setOpen(id);
      if (scroll) { var t = root.querySelector('#sn-moms'); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
    function close(scroll) {
      setOpen(null);
      if (scroll) { var t = root.querySelector('#sn-moms'); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
    setOpen(null);
    cards.forEach(function (c) {
      c.addEventListener('click', function (e) {
        if (e.target.closest('a, form, input')) return;
        var id = c.getAttribute('data-mom');
        if (c.getAttribute('data-open') === 'true') { close(false); return; }
        setOpen(id);
        var p = root.querySelector('.sn-panel[data-mom="' + id + '"]');
        if (p && p.getBoundingClientRect().top > window.innerHeight * 0.6) { p.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
    root.querySelectorAll('[data-close-panel]').forEach(function (b) {
      b.addEventListener('click', function () { close(true); });
    });
    root.querySelectorAll('[data-go-mom]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); show(a.getAttribute('data-go-mom'), true); });
    });
    var drop = root.querySelector('[data-drop]');
    if (drop) {
      var target = Date.parse(drop.getAttribute('data-drop'));
      var count = drop.querySelector('[data-count]');
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      var tick = function () {
        if (isNaN(target)) { count.style.display = 'none'; return; }
        var ms = target - Date.now();
        if (ms <= 0) { count.innerHTML = '<div><b>Live now!</b></div>'; return; }
        var mins = Math.floor(ms / 60000);
        drop.querySelector('[data-d]').textContent = pad(Math.floor(mins / 1440));
        drop.querySelector('[data-h]').textContent = pad(Math.floor((mins % 1440) / 60));
        drop.querySelector('[data-m]').textContent = pad(mins % 60);
        setTimeout(tick, 30000);
      };
      tick();
    }
  }
  function all() { document.querySelectorAll('.sn').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', all); } else { all(); }
  document.addEventListener('shopify:section:load', all);
  document.addEventListener('shopify:block:select', function (e) {
    var card = document.querySelector('.sn-card[data-block="' + e.detail.blockId + '"]');
    if (card && card.getAttribute('data-open') !== 'true') card.click();
  });
})();